const ApiUrl = 'https://pds.goldpos.com.co/apiGold/';

const ApiRaiz = 'https://pds.goldpos.com.co/';


const BackgroundColor = '#4175CB';


export { ApiUrl, BackgroundColor,ApiRaiz }
